import * as Mustache from 'mustache';

// usage
// {{ printIf(link.key === 'home', }}
var IF = function(condition, value, elseValue) {
  if (typeof elseValue !== 'undefined')
    return condition ? value : elseValue;
  else
    return condition ? value : '';
}

var KEY = function(obj, key) {
  return (typeof obj[key] !== 'undefined' ? obj[key] : '');
}

var MAX = function(data) {
  if (data instanceof Array)
    return Math.max.apply(null, data);
  else
    return Math.max.call(this, data);
}

var MIN = function(data) {
  if (data instanceof Array)
    return Math.min.apply(null, data);
  else
    return Math.min.call(this, data);
}

var CEIL = function(data) {
  if (data instanceof Array)
    return Math.ceil.apply(null, data);
  else
    return Math.ceil.call(this, data);
}

var ROUND = function(data) {
  if (data instanceof Array)
    return Math.round.apply(null, data);
  else
    return Math.round.call(this, data);
}

var FLOOR = function(data) {
  if (data instanceof Array)
    return Math.floor.apply(null, data);
  else
    return Math.floor.call(this, data);
}

// 先將變數代入公式
function myEval(params, formula, options) {

  params.IF = IF;
  params.KEY = KEY;
  params.MAX = MAX;
  params.MIN = MIN;
  params.ROUND = ROUND;
  params.CEIL = CEIL;
  params.FLOOR = FLOOR;

  // console.log('params ', params);
  // console.log('formula ', formula);
  var mathFormula = Mustache.render(formula, params);
  console.log(mathFormula);
  var total;
  try {
    total = eval(mathFormula);
  } catch (e) {
    if (e.name === 'SyntaxError') {
      var error = new Error('Your formula is incorrect ' + mathFormula);
      error.name = 'SyntaxError';
      throw error;
    }
    throw e;
  }

  if (options && options.stateKey) {
    if (!params.result)
      params.result = {};

    params.result[options.stateKey] = total;
  }

  // debug('mathFormula: ' + mathFormula);

  return total;
}

function myParse(params, formula) {
  params.IF = IF;
  params.KEY = KEY;
  params.MAX = MAX;
  params.MIN = MIN;

  if (!(typeof formula === 'string')) {
    throw new Error('We expect formula to be a string');
  }
  var mathFormula = Mustache.render(formula, params);
  // debug('mathFormula: ' + mathFormula);
  return mathFormula;
}

export { myEval, myParse }